import { useRef, useState, useCallback } from 'react';

export default function useDraggableScroll() {
    const ref = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);

    const onMouseDown = useCallback((e) => {
        if (!ref.current) return;
        setIsDragging(true);
        // getBoundingClientRect는 뷰포트 기준이므로 e.clientX와 함께 사용
        const rect = ref.current.getBoundingClientRect();
        setStartX(e.clientX - rect.left);
        setScrollLeft(ref.current.scrollLeft);
    }, []);

    const onMouseLeave = useCallback(() => {
        setIsDragging(false);
    }, []);

    const onMouseUp = useCallback(() => {
        setIsDragging(false);
    }, []);

    const onMouseMove = useCallback((e) => {
        if (!isDragging || !ref.current) return;
        e.preventDefault();
        const rect = ref.current.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const walk = (x - startX) * 1.5; // 감도 조절
        ref.current.scrollLeft = scrollLeft - walk;
    }, [isDragging, startX, scrollLeft]);

    return {
        ref,
        onMouseDown,
        onMouseLeave,
        onMouseUp,
        onMouseMove,
        isDragging
    };
}
